"use strict";
/**
 * Created by SH 16/03/2019
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateHandler = void 0;
class StateHandler {
    get state() { return this._currentState; }
    get subState() { return this._subState; }
    set subState(value) { this._subState = value; }
    get lastState() { return this._lastState; }
    constructor(state) { this._lastState = this._subState = this._currentState = state; }
    equal(value, subState) {
        return subState ? this._subState === value : this.state === value;
    }
    set(value, subState) {
        this._lastState = this._currentState;
        if (subState)
            this._subState = value;
        else
            this._currentState = value;
    }
}
exports.StateHandler = StateHandler;
//# sourceMappingURL=StateHandler.js.map